module.exports = __webpack_public_path__ + "img/plane_track_2.67372cd0.svg";